import {Component, Input} from '@angular/core';
import {SearchResultEntry} from "../../../../api/models/search-result-entry";

@Component({
  selector: 'app-search-data-plugin',
  templateUrl: './search-data-plugin.component.html',
  styleUrls: ['./search-data-plugin.component.scss']
})
export class SearchDataPluginComponent {
  @Input()
  searchResultEntry!: SearchResultEntry;
  constructor() { }
}
